/* 1g — the Watercraft strip inside the booking confirmation ticket.
   Ported from `01-placements/1g_booking-confirmation-single-line-strip.html`.
   Colours are remapped onto the app palette in the homepage banner's
   `tokens.js`.

   The pack is explicit on two points: this asset is STATIC — the copy stays
   generic and is never templated with the booking's venue, dates or swim —
   and its CTA is the only entry point to 1f on this page, opened as a
   lightbox. `onTellMeMore` is that hook.

   Fluid rather than the pack's fixed 390px, so it spans the ticket's
   content column. */
import React from 'react';
import {
  wcColors,
  wcFonts,
  wcOnAccent,
} from '../../../../home/components/watercraft/tokens';
import '../../../assets/css/watercraft_ticket_strip.css';

export default function WatercraftTicketStrip({ onTellMeMore }) {
  return (
    <div
      className='wc-1g'
      style={{
        width: '100%',
        display: 'flex',
        alignItems: 'center',
        gap: '11px',
        background: wcColors.bg,
        border: `1px solid ${wcColors.border}`,
        borderRadius: '12px',
        padding: '14px',
        boxSizing: 'border-box',
        boxShadow: '0 18px 40px rgba(18,35,46,.14)',
      }}
    >
      <div style={{ flex: '1', minWidth: '0' }}>
        <div
          style={{
            fontFamily: wcFonts.body,
            fontSize: '13px',
            fontWeight: '600',
            color: wcColors.textPrimary,
            lineHeight: '1.3',
            marginBottom: '4px',
            whiteSpace: 'nowrap',
          }}
        >
          Want an edge for this session?
        </div>
        <div
          style={{
            fontFamily: wcFonts.body,
            fontSize: '12px',
            color: wcColors.textSecondary,
            fontWeight: '300',
            lineHeight: '1.45',
            textWrap: 'pretty',
          }}
        >
          Get likely fish feeding times and more using Watercraft&trade;
        </div>
      </div>

      {/* A button rather than the pack's `<a href="#1f">`: 1f opens here as a
          lightbox, so there is nothing to navigate to. */}
      <button
        type='button'
        className='wc-1g__cta'
        onClick={onTellMeMore}
        style={{
          flex: 'none',
          alignSelf: 'center',
          background: wcColors.accent,
          color: wcOnAccent,
          fontFamily: wcFonts.body,
          fontSize: '12.5px',
          fontWeight: '700',
          padding: '10px 13px',
          borderRadius: '8px',
          whiteSpace: 'nowrap',
          border: 0,
          cursor: 'pointer',
        }}
      >
        Tell me more
      </button>
    </div>
  );
}
